import { FC } from 'react';
import { Link } from 'react-router-dom';
import { CONVERSATION_PHRASE_PARAM, useConversationLink } from '@/entities/conversations';
import type { PhraseAuditItem } from '@/entities/phrases';

type Props = {
  /** Реплика строки перечня */
  phrase: PhraseAuditItem;
};

/**
 * Диалог реплики ссылкой на его карточку, открытую на этой самой реплике: карточка прокручивается
 * к ней и выделяет её — тем же способом, что и переход к найденной реплике из списка диалогов.
 *
 * Ссылка обычная, поэтому нажатие с модификатором или средней кнопкой открывает диалог в новой
 * вкладке. Возврат из карточки ведёт в аудит с прежним перечнем — по общему контракту возврата
 * ({@link useConversationLink}): текущий адрес раздела несёт окно, отбор и порядок перечня.
 *
 * Из обхода с клавиатуры ссылка исключена — тем же решением, что и кнопки прослушивания: обход
 * перечня ведёт из текста реплики в текст следующей, а ссылка стоит первой колонкой и разрывала бы
 * сплошной проход вычитки на каждой строке.
 */
export const PhraseConversationLink: FC<Props> = ({ phrase }) => {
  const buildLink = useConversationLink();

  const { to, state } = buildLink(phrase.conversationId, { [CONVERSATION_PHRASE_PARAM]: String(phrase.id) });

  return (
    <Link
      to={to}
      state={state}
      tabIndex={-1}
      className="text-primary hover:underline"
      data-testid="phrase-conversation-link"
    >
      {phrase.conversationId}
    </Link>
  );
};
